/* eslint react/display-name: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import bgWorks from "../images/works-bg-4.jpg"
import { graphql } from 'gatsby'
import { useTrail } from 'react-spring'
import { Container, Layout, Hero, BGImage, ProjectItem } from '../components'
import { animated, useSpring, config } from 'react-spring'


const Content = styled(Container)`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 2rem;
    padding-bottom: 2rem;
    z-index: 3;
`

const Title = styled(animated.h1)`
    margin-top: 0;
`

const ListWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    width: 100%;
`

const Works = ({
    data: {
        allMdx: { nodes: projectEdges },
    },
    location,
}) => {
  const trail = useTrail(projectEdges.length, {
    from: { height: '100%' },
    to: { height: '100%' },
})

const titleProps = useSpring({
    config: config.slow,
    from: { opacity: 0, transform: 'translate3d(0, -30px, 0)' },
    to: { opacity: 1, transform: 'translate3d(0, 0, 0)' },
})

const contentProps = useSpring({ config: config.slow, delay: 500, from: { opacity: 0 }, to: { opacity: 1 } })

return (
    <Layout pathname={location.pathname}>

        <Hero single>
            <BGImage single>
                 <img className="services__item--img" src={bgWorks} alt="Front End Development" />
            </BGImage>
            <Content type="text">
                <Title data-testid="single-title" style={titleProps}> 01. Works</Title>
            </Content>
        </Hero>

        <Container type="text">
            <animated.div style={contentProps} ></animated.div>
        </Container>

        <ListWrapper>
            {trail.map((style, index) => (
            <ProjectItem
                testid={`projectItem-${index}`}
                style={style}
                key={projectEdges[index].fields.slug}
                node={projectEdges[index]}
            />
            ))}
        </ListWrapper>
    </Layout>
  )
}

export default Works

Works.propTypes = {
  data: PropTypes.shape({
    allMdx: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          fields: PropTypes.shape({
            slug: PropTypes.string,
          }),
          frontmatter: PropTypes.shape({
            service: PropTypes.string,
            color: PropTypes.string,
            client: PropTypes.string,
            cover: PropTypes.any,
          }),
        })
      ),
    }),
  }).isRequired,
  location: PropTypes.object.isRequired,
}

export const pageQuery = graphql`
  query WorksQuery {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { sourceInstanceName: { eq: "projects" } } }
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          service
          color
          client
          cover {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
            resize(width: 800) {
              src
            }
          }
        }
        }
      }
    }
  }
`
